import { Map, List } from "immutable";

import alsPoster from '../img/als-poster.jpg';
import acceptance from '../img/acceptance.jpg';
import angerAndDepression from '../img/anger-and-depression.jpg';
import bargaining from '../img/bargaining.jpg';
import bargaining2 from '../img/bargaining2.jpg';
import denial from '../img/denial.jpg';
import fattyAcidUptake from '../img/fatty-acid-uptake.jpg';
import viabilityPoster from '../img/viability-poster.jpg';
import autophagy from '../img/autophagy.jpg';
import phdPoster from '../img/phd-poster.jpg';
import dietaryRestriction from '../img/dietary-restriction.jpg';
import hypothalamic from '../img/hypothalamic.jpg';
import maleInfertility from '../img/male-infertility.jpg';
import biofilms from '../img/biofilms.jpg';
import about from '../img/about.png';
import exhibition from '../img/exhibition.jpg';

import motorNeuronLossInAls from '../content/motor-neuron-loss-in-als';
import saturatedFatsAreToxic from "../content/saturated-fats-are-toxic";
import saturatedAndMonounsaturatedFats from "../content/saturated-and-monounsaturated-fats";
import howAreFats from "../content/how-are-fats";
import whereAreFats from "../content/where-are-fats";
import theRoadToAcceptance from '../content/the-road-to-acceptance';
import denialContent from '../content/denial';
import bargainingContent from '../content/bargaining';
import angerAndDepressionContent from '../content/anger-and-depression';
import acceptanceContent from '../content/acceptance';
import understandingDietaryRestriction from "../content/understanding-dietary-restriction";
import theArtOfCommunicatingScience from "../content/the-art-of-communicating-science";
import energyBalanceContent from "../content/energy-balance";
import maleInfertilityContent from "../content/male-infertility";
import hypothalamicContent from "../content/hypothalamic";
import biofilmsContent from "../content/biofilms";
import careerContent from "../content/career";
import educationContent from "../content/education";
import bioContent from "../content/bio";



export default Map({
    audioIsAllowed: false, // change this to false to turn on permission
    menuIsVisible: false,
    menuItems: List([
        Map({ label: 'home', link: '/', isInDesktopNav: false}),
        Map({ label: 'About', link: '/about', isInDesktopNav: true}),
        Map({ label: 'Science', link: '/science', isInDesktopNav: true}),
        Map({ label: 'Art', link: '/art', isInDesktopNav: true}),
        Map({ label: 'Contact', link: '/contact', isInDesktopNav: true})
    ]),
    art: List([
        Map({
            title: 'The Art Of Communicating Science: Energy Balance In Obesity (2023)',
			image: {src: bargaining, fit: 'contain', position: 'center'}, video: false, caption: 'Exhibited: Centre for Systems Modelling and Quantitative Biomedicine Artist-in-Residence, Centrala, Birmingham, 2022.',
            article: energyBalanceContent,
		}),
        Map({
            title: 'The Art Of Communicating Science: Biofilms: A City Of Microbes (2023)',
			image: {src: biofilms, fit: 'contain', position: 'center'}, video: false, caption: 'Exhibited: Centre for Systems Modelling and Quantitative Biomedicine Artist-in-Residence, Centrala, Birmingham, 2022.',
            article: biofilmsContent,
		}),
        Map({
            title: 'The Art Of Communicating Science: Hypothalamic-Pituitary-Adrenal Axis (2023)',
			image: {src: hypothalamic, fit: 'contain', position: 'center'}, video: false, caption: 'Exhibited: Centre for Systems Modelling and Quantitative Biomedicine Artist-in-Residence, Centrala, Birmingham, 2022.',
            article: hypothalamicContent,
		}),
        Map({
            title: 'The Art Of Communicating Science: Male Infertility And How Sperm Swim (2023)',
			image: {src: maleInfertility, fit: 'contain', position: 'center'}, video: false, caption: 'Exhibited: Centre for Systems Modelling and Quantitative Biomedicine Artist-in-Residence, Centrala, Birmingham, 2022.',
            article: maleInfertilityContent,
		}),
        Map({
            title: 'The Art Of Communicating Science (Collection) (2023)',
			image: null,
            images: [
                {src: maleInfertility, fit: 'contain'}, 
                {src: hypothalamic, fit: 'contain'}, 
                {src: biofilms, fit: 'contain'}, 
                {src: bargaining, fit: 'contain'} 
            ],
            article: theArtOfCommunicatingScience,
		}),
        Map({
            title: 'The Road To Acceptance: Acceptance (2022)',
			image: {src: acceptance, fit: 'contain', position: 'center'}, video: false, caption: 'Exhibited: Centre for Systems Modelling and Quantitative Biomedicine Artist-in-Residence, Centrala, Birmingham, 2022.',
            article: acceptanceContent,
		}),
        Map({
            title: 'The Road To Acceptance: Anger And Depression (2022)',
			image: {src: angerAndDepression, fit: 'contain', position: 'center'}, video: false, caption: 'Exhibited: Centre for Systems Modelling and Quantitative Biomedicine Artist-in-Residence, Centrala, Birmingham, 2022.',
            article: angerAndDepressionContent,
		}),
        Map({
            title: 'The Road To Acceptance: Bargaining (2022)',
			image: {src: bargaining2, fit: 'contain', position: 'center'}, video: false, caption: 'Exhibited: Centre for Systems Modelling and Quantitative Biomedicine Artist-in-Residence, Centrala, Birmingham, 2022.',
            article: bargainingContent,
		}),
        Map({
            title: 'The Road To Acceptance: Denial (2022)',
			image: {src: denial, fit: 'contain', position: 'center'}, video: false, caption: 'Exhibited: Centre for Systems Modelling and Quantitative Biomedicine Artist-in-Residence, Centrala, Birmingham, 2022.',
            article: denialContent,
		}),
        Map({
            title: 'The Road To Acceptance: Learning To Live With Epilepsy (Collection) (2022)',
            subtitle: 'The Five Stages Of Grief',
			image: null,
            images: [
                {src: denial, fit: 'contain'}, 
                {src: bargaining2, fit: 'contain'}, 
                {src: angerAndDepression, fit: 'contain'}, 
                {src: acceptance, fit: 'contain'}, 
            ],
            caption: 'Exhibited: Centre for Systems Modelling and Quantitative Biomedicine Artist-in-Residence, Centrala, Birmingham, 2022.',
            article: theRoadToAcceptance
		}),
    ]),
    images: List([
        Map({
            title: 'Bio',
            url: false,
            image: {src: exhibition, fit: 'cover'}, 
            article: bioContent
        }),
        Map({
            title: 'Education',
            url: false,
            image: {src: about, fit: 'cover'}, 
            article: educationContent
        }),
        Map({
            title: 'Career To Date',
            url: false,
            image: {src: about, fit: 'cover'}, 
            article: careerContent
        })
    ]),
	science: List([
        Map({ 
            title: 'Understanding how dietary restriction extends the lifespan of cells', 
            poster: {src: dietaryRestriction, fit: "cover"}, 
            link: '/dietary-restriction',
            article: understandingDietaryRestriction
        }),
        Map({ 
            title: 'The effect of saturated and monounsaturated fats on the recycling system of insulin-producing pancreatic beta cells', 
            poster: {src: autophagy, fit: "cover"}, 
            link: '/autophagy.pdf',
            article: saturatedAndMonounsaturatedFats
        }),
        Map({ 
            title: 'Saturated fats are toxic to rodent insulin-producing pancreatic beta cells, but are they toxic to human beta cells?', 
            poster: {src: viabilityPoster, fit: "cover"}, 
            link: '/viability-poster.pdf',
            article: saturatedFatsAreToxic
        }),
		Map({ 
            title: 'Where are fats transported to inside insulin-producing pancreatic beta cells?', 
            poster: {src: phdPoster, fit: "cover"}, 
            link: '/viability-poster.pdf',
            article: whereAreFats
        }),
        Map({ 
            title: 'How are fats taken up into insulin-producing pancreatic beta cells?', 
            poster: {src: fattyAcidUptake, fit: "cover"}, 
            link: '/fatty-acid-uptake.pdf',
            article: howAreFats
        }),
        Map({ 
            title: 'Motor neuron loss in Amyotrophic Lateral Sclerosis', 
            poster: {src: alsPoster, fit: "contain", position: "left"},  
            image: null, 
            link: '/als-poster.pdf',
            tags: null,
            article: motorNeuronLossInAls
        })
	]),
});



// WEBPACK FOOTER //
// ./src/data/initial.js